module.exports = "//static.hsappstatic.net/salesImages/static-1.403/sales-pro-onboarding/pql-modal/pql-calling.png"